import { createClient } from '@supabase/supabase-js';

import {
  JOB_STATUSES,
  JOB_STATUS_LABELS,
  JOB_STATUS_VALUES
} from './hiring-status';

const supabaseUrl = process.env.GATSBY_SUPABASE_URL || process.env.SUPABASE_URL || '';
const supabaseAnonKey =
  process.env.GATSBY_SUPABASE_PUBLISHABLE_KEY ||
  process.env.GATSBY_SUPABASE_ANON_KEY ||
  process.env.SUPABASE_PUBLISHABLE_KEY ||
  process.env.SUPABASE_ANON_KEY || '';

const SUPABASE_SINGLETON_KEY = '__grafitoSupabaseClient';
const SUPABASE_CLIENT_VERSION = 5;

/**
 * Stop timers on a cached client from an older bundle and drop the singleton.
 */
export function purgeStaleSupabaseClient() {
  if (typeof window === 'undefined') return;

  const existing = window[SUPABASE_SINGLETON_KEY];
  if (existing?.auth?.stopAutoRefresh) {
    void existing.auth.stopAutoRefresh();
  }

  delete window[SUPABASE_SINGLETON_KEY];
}

function isCurrentClient(client) {
  return Boolean(client && client.__grafitoClientVersion === SUPABASE_CLIENT_VERSION);
}

/** Bypass Navigator LockManager entirely — it breaks under Gatsby HMR. */
async function grafitoAuthLock(_name, _acquireTimeout, fn) {
  return fn();
}

function createBrowserClient() {
  const client = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: true,
      persistSession: true,
      lock: grafitoAuthLock,
    },
  });

  client.__grafitoClientVersion = SUPABASE_CLIENT_VERSION;
  return client;
}

function getSupabaseClient() {
  if (!supabaseUrl || !supabaseAnonKey) return null;
  if (typeof window === 'undefined') return null;

  const existing = window[SUPABASE_SINGLETON_KEY];
  if (isCurrentClient(existing)) {
    return existing;
  }

  if (existing) {
    purgeStaleSupabaseClient();
  }

  const client = createBrowserClient();
  window[SUPABASE_SINGLETON_KEY] = client;
  return client;
}

export function getSupabase() {
  return getSupabaseClient();
}

export { JOB_STATUSES, JOB_STATUS_LABELS, JOB_STATUS_VALUES };
